import {Row} from "@tanstack/react-table";


export function isDatetimeStringFormatSorter<TData>(rowA: Row<TData>, rowB: Row<TData>, columnId: string) {
    const rowValueA = rowA.original[columnId] as string;
    const rowValueB = rowB.original[columnId] as string;
    const dateA = new Date(rowValueA);
    const dateB = new Date(rowValueB);
    if (dateA < dateB) {
        return -1;
    } else if (dateA > dateB) {
        return 1;
    }
    return 0;
}